import React from 'react';
import { Alert } from '@lightspeed/flame/Alert';
import Text from '@lightspeed/cirrus-text';

const NoRights = ({
  rights = '',
  customText = null,
}: {
  rights?: string;
  customText?: React.ReactElement | null;
}) => (
  <div className="react-page__listing">
    <Alert type="warning" noCloseBtn>
      {customText || (
        <Text>
          Access restricted. <var>&apos;{rights}&apos;</var> right(s) required.
        </Text>
      )}
    </Alert>
  </div>
);

export default NoRights;
